import { useUniversityInformation } from '@helpers/use';

import { Box, Button, Modal, Typography } from '@mui/material';

import Image from '@components/atoms/image';
import { getAssetUrl, sanitize } from '@helpers/utils';

import { useRouter } from 'next/router';
import 'video.js/dist/video-js.css';
import React, { useState } from 'react';

import { useTranslation } from 'next-i18next';

import { CollaborationContainer, VideoContainer } from './style';

export const CollaborationSection = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);

  return (
    <CollaborationContainer>
      <Box width={{ md: '100%', lg: '50%' }} textAlign={{ xs: 'center', md: 'center', lg: 'unset' }}>
        <Typography variant="h4" fontWeight={500} lineHeight={1} marginBottom={1} color="#00000099">
          {t('academic_landing_page.course_section.collaboration_title')}
        </Typography>
        <Typography
          variant="h3"
          fontSize={{ xs: 24, sm: 30 }}
          lineHeight={{ sm: '34px' }}
          fontWeight={{ xs: 500, sm: 700 }}
          marginBottom={3}
        >
          {landingPage?.collaborationSectionHeading}
        </Typography>
        <Typography variant="body2_deprecated" color="#00000099">
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={sanitize(landingPage?.collaborationDescription || '')}
          />
        </Typography>
      </Box>

      <Box
        flex={1}
        width={{ sm: '50%', md: '100%' }}
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
        onClick={handleOpen}
        sx={{ cursor: 'pointer' }}
      >
        <Image
          src={landingPage?.collaborationIllustrationImageUrl}
          errorImage={getAssetUrl('thumbnail-course-card.jpg')}
          alt="Colloboration image"
        />
      </Box>

      <Modal open={open} onClose={handleClose} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <VideoContainer id="my-video" className="video-js" controls>
          <source src={landingPage?.collaborationIllustrationVideoUrl || ''} type="video/mp4" />
        </VideoContainer>
      </Modal>
    </CollaborationContainer>
  );
};
